<template>
  <div class="p-r">
    <div ref="map" :class="mapElementClass"></div>
    <div style="display: none">
      <div ref="popup">
        <component
          :is="cardComponent"
          v-if="highlighted"
          :card="highlighted"
          class="offer-card--popup o-h p-r bg-white"
          @click.native="handleCardClick"
          :url="getDetailUrl(highlighted.url)"
          :display-price-per-sqm="displayPricePerSqm"
        />
      </div>
    </div>
    <transition name="fade-in">
      <div
        class="bottom-right mb-24 mr-24 show-for-large pointer-none"
        v-if="showZoom"
      >
        <div class="mb-8">
          <button
            class="button-reset bg-white px-16 py-16 pointer-auto border br-4"
            aria-label="Zoom in"
            @click="zoom(true)"
          >
            <svg width="32" height="32">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.388 16.52V28h1V16.52h11.479v-1h-11.48V4h-1v11.52H3.868v1h11.52z"
                fill="currentColo"
              />
            </svg>
          </button>
        </div>
        <button
          class="button-reset bg-white px-16 py-16 pointer-auto border br-4"
          aria-label="Zoom out"
          @click="zoom(false)"
        >
          <svg width="32" height="32">
            <path d="M3.99 16.51h24" stroke="currentColor" />
          </svg>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import Card from './card.vue'
import CardOffice from './card-office.vue'
import CardAmenity from './card-amenity.vue'
import GoogleMap from '../google-map'
import { loadGoogleApis } from '../../../main/src/scripts/lib/loadGoogleApis'

export default {
  name: 'MapWithPopup',
  components: {
    Card,
    CardOffice,
    CardAmenity,
  },
  data() {
    return {
      highlighted: null,
    }
  },
  async mounted() {
    this.circleObjects = []
    this.googleMap = new GoogleMap(this.$refs.map, {
      markersDir: this.markersDir,
      onMarkerClick: (markerData) => {
        this.highlighted = markerData
      },
      infowindowContent: this.$refs.popup,
      useCircles: this.useCircles,
      mapOptions: this.mapOptions,
      noClusterer: this.noClusterer,
      swissCoordinates: this.swissCoordinates,
      onBoundsChange: (bounds) => this.$emit('boundschange', bounds),
      initialBounds: this.initialBounds,
    })
    this.googleMap.setMarkers(this.markers)
    if (!this.disableAutoFit) {
      this.googleMap.fitToMarkers()
    }
  },
  props: {
    markers: {
      type: Array,
    },
    useCircles: {
      type: Boolean,
    },
    mapElementClass: {
      type: String,
    },
    markersDir: {
      type: String,
    },
    onPopupClick: {
      type: Function,
    },
    cardComponent: {
      type: String,
      default: 'card',
    },
    showZoom: {
      type: Boolean,
      default: true,
    },
    mapOptions: {
      type: Object,
    },
    noClusterer: {
      type: Boolean,
    },
    swissCoordinates: {
      type: Boolean,
    },
    getDetailUrl: {
      type: Function,
      default: () => {},
    },
    displayPricePerSqm: {
      type: Boolean,
      default: false,
    },
    initialBounds: {
      type: Object,
      default: null,
    },
    disableAutoFit: {
      type: Boolean,
      default: false,
    },
    circles: {
      type: Array,
      default: [],
    }
  },
  watch: {
    markers(newMarkers) {
      this.googleMap.setMarkers(newMarkers)
      if (!this.disableAutoFit) {
        this.googleMap.fitToMarkers()
      }
    },
    useCircles(useCircles) {
      this.googleMap.setUseCircles(useCircles)
    },
    async circles() {
      const google = await loadGoogleApis()

      for (const googleCircle of this.circleObjects) {
        googleCircle.setMap(null)
      }
      this.circleObjects = this.circles.map(({ center, radius }) => {
        return new google.maps.Circle({
          strokeColor: "#1e713f",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#1e713f",
          fillOpacity: 0.35,
          map: this.googleMap.map,
          center,
          radius,
        })
      })
    }
  },
  methods: {
    zoom(increase) {
      const zoom = this.googleMap.map.getZoom()
      this.googleMap.map.setZoom(increase ? zoom + 1 : zoom - 1)
    },
    handleCardClick() {
      if (this.onPopupClick) {
        this.onPopupClick(this.highlighted)
      }
    },
  },
}
</script>